import {Configuration} from '@domain/model/Config/Configuration';

interface LOG {
  config: Configuration;
}

declare global {
  interface Window {
    dataLayer: Array<object>;
    location: Location;
    LOG: LOG;
  }
}

export {};
